



































































import Vue from 'vue'
import { faEye, faEyeSlash, faLock } from '@fortawesome/free-solid-svg-icons'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'

export default Vue.extend({
  components: { CFormError },
  props: {
    value: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    state: {
      type: Boolean,
      default: null
    },
    loading: {
      type: Boolean,
      required: true,
      default: false
    },
    autocomplete: {
      type: String,
      required: false,
      default: 'current-password'
    },
    labelClass: {
      type: String,
      required: false,
      default: 'mb-1'
    },
    formGroupClass: {
      type: String,
      required: false,
      default: ''
    },
    error: {
      type: String,
      required: false,
      default: ''
    },
    required: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      showPass: false,
      focused: false
    }
  },
  computed: {
    icons() {
      return {
        showPass: faEye,
        hidePass: faEyeSlash,
        lock: faLock
      }
    },
    showHidePassIcon() {
      return this.showPass ? this.icons.hidePass : this.icons.showPass
    },
    showHidePassTitle() {
      return this.showPass
        ? this.$t('hide password')
        : this.$t('reveal password')
    }
  },
  methods: {
    resetShowPass() {
      this.showPass = false
    }
  }
})
